import React, { useContext } from "react";
import PropTypes from "prop-types";
import {default as MuiDrawer} from "@mui/material/Drawer";
import context from "components/Shared/MSidebar/utility/context";
import { classes } from "components/Utility";

const Drawer = ({
  children,
  className
}) => {
  const { open } = useContext(context);

  return (
    <MuiDrawer
      className={classes("Drawer-Root", open ? " Drawer-Open" : " Drawer-Closed", className)}
      {...{open}}
      variant={"permanent"}
    >
      {children}
    </MuiDrawer>
  );
};

Drawer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
};

export default Drawer;
